import { useEffect, useRef, useState } from 'react';
import useFirstRender from '@/common/hooks/useIsFirstRender.ts';

const useRenderWithDelay = (show: boolean, delayTime: number) => {
  const isFirstRender = useFirstRender();
  const [isRender, setIsRender] = useState(show);
  const timeOutRef = useRef<any>(null);
  useEffect(() => {
    const changeRendering = () => {
      if (!show) {
        timeOutRef.current = setTimeout(() => {
          setIsRender(false);
          clearTimeout(timeOutRef.current);
        }, delayTime);
      } else {
        setIsRender(true);
        clearTimeout(timeOutRef.current);
      }
    };
    if (!isFirstRender) {
      changeRendering();
    }
  }, [show]);

  return { isRender };
};
export default useRenderWithDelay;
